import React from 'react';
import Navbar from '../../../components/Navbar';
import Footer from '../../../components/Footer';
import Copyright from '../../../components/Copyright';
import PredictiveAnalytics from './PredictiveAnalytics';

export default function Blog() {
  return (
    <>
        <Navbar />
        <PredictiveAnalytics />
        <Footer />
        <Copyright />
    </>
  )
}